export default {
  en: {
    CAP: 'Cap',
    ALL: 'All',
    WEEKDAY: 'Weekday'
  }
};